<template>
  <div class="card-display-container" :class="{'card-reverse': isReverse, 'card-default-sm': isDefaultOrderSm, 'content-static-info': isStaticInfoCard}">
    <div class="card-image-wrapper" ref="imageWrapper" @click="imageClick" :style="slideShowPhotos&&!playSlideShow?'cursor: pointer':''">
      <!--<div class="card-image" :class="imageClass" :style="getImageStyle"></div>-->
      <!--<div class="card-image-blur-wrapper" v-if="isBlurBackground">-->
      <!--<div class="card-image blur-background" :class="imageClass" :style="getBlurImageStyle"></div>-->
      <!--</div>-->
      <v-carousel cycle height="100%" :interval="3000" hide-delimiters :show-arrows="false" v-if="playSlideShow" class="carosuel">
        <v-carousel-item v-for="p in slideShowPhotos"
                         :key="p.id"
                         reverse-transition="fade-transition"
                         transition="fade-transition"
                         :href="p.link"
                         contain
        >
          <div class="card-image-blur-wrapper">
            <svg :id="'svg_' + p.id" :width="svgWrapperWidth" :height="svgWrapperHeight">
              <filter :id="'blurMe_' + p.id" filterRes="1200" color-interpolation-filters="sRGB">
                <feGaussianBlur in="SourceGraphic" stdDeviation="20"/>
              </filter>

              <image :xlink:href="p.image" :x="imageWrapperX" :y="imageWrapperY" :width="imageWrapperWidth" :height="imageWrapperHeight" :filter="'url(#blurMe_' + p.id + ')'"/>
            </svg>
          </div>
          <div class="card-image" :class="imageClass" :style="getImageStyle(p.image, true)"></div>
        </v-carousel-item>
      </v-carousel>
      <div v-if="!playSlideShow">
        <div class="card-image-blur-wrapper">
          <svg id="svg" :width="svgWrapperWidth" :height="svgWrapperHeight">
            <filter id="blurMe" filterRes="1200" color-interpolation-filters="sRGB">
              <feGaussianBlur in="SourceGraphic" stdDeviation="20"/>
            </filter>

            <image :xlink:href="this.imageSrc" :x="imageWrapperX" :y="imageWrapperY" :width="imageWrapperWidth" :height="imageWrapperHeight" filter="url(#blurMe)"/>
          </svg>
        </div>
        <div class="card-image" :class="imageClass" :style="getImageStyle(imageSrc, isBlurBackground)"></div>

        <font-awesome-icon class="card-play-button" icon="play-circle" :size="(parseInt((pageWidth/300))+3) + 'x'" fixed-width v-if="slideShowPhotos"></font-awesome-icon>
      </div>
    </div>
    <div class="card-content-wrapper">
      <v-row class="flex-grow-0">
        <v-col cols="12" lg="6">
          <div class="card-sub-title title-font">
            <slot name="sub-title"></slot>
          </div>
          <div class="card-title title-font">
            <slot name="title"></slot>
          </div>
          <div>
            <slot name="action"></slot>
          </div>
        </v-col>
        <v-col cols="12" lg="6"
               :class="['card-gym-availability', {'text-right': $vuetify.breakpoint.lgAndUp}]"
               v-if="$slots['gym-availability']">
          <slot name="gym-availability"></slot>
        </v-col>
      </v-row>
      <div class="card-divider">
        <div class="vert-divider"></div>
      </div>
      <div class="card-content">
        <slot name="content"></slot>
      </div>
    </div>
  </div>
</template>

<script>
// import {frostedPanel} from './frostpanel'
export default {
  name: 'HkiaraceCardDisplayFrame',
  props: {
    imageSrc: String,
    imageClass: String,
    imageMinHeight: String,
    slideShowPhotos: Array,
    isReverse: Boolean,
    isDefaultOrderSm: Boolean,
    pageWidth: Number,
    isStaticInfoCard: Boolean,
    isBlurBackground: Boolean,
  },
  data() {
    return {
      imageWrapperX: 0,
      imageWrapperY: 0,
      imageWrapperWidth: 0,
      imageWrapperHeight: 0,
      svgWrapperWidth: 0,
      svgWrapperHeight: 0,
      playSlideShow: false,
    };
  },
  methods: {
    imageClick() {
      if (this.slideShowPhotos && !this.playSlideShow) {
        this.playSlideShow = true
      }
    },

    resizeImageWrapper() {
      // console.log(this.$refs.imageWrapper.clientHeight, this.$refs.imageWrapper.clientWidth);
      this.svgWrapperWidth = this.$refs.imageWrapper.clientWidth;
      this.svgWrapperHeight = this.$refs.imageWrapper.clientHeight;
      this.imageWrapperWidth = this.$refs.imageWrapper.clientWidth * 4;
      this.imageWrapperHeight = this.$refs.imageWrapper.clientHeight * 4;
      this.imageWrapperX = -this.$refs.imageWrapper.clientWidth * 1.5;
      this.imageWrapperY = -this.$refs.imageWrapper.clientHeight * 1.5;
    },

    getImageStyle(imageUrl, isBlur) {
      let style = {};
      if (this.pageWidth <= 1200) {
        style['paddingTop'] = '50%';
        // style['height'] = '100px';
      } else if (this.imageMinHeight) {
        style['min-height'] = this.imageMinHeight;
      }

      if (!imageUrl) {
        return style
      }
      style['background-image'] = `url(${imageUrl})`

      style['background-size'] = isBlur ? 'contain' : 'cover'

      return style
    },
  },
  mounted() {
    // console.log('wdith: ' + this.$el.clientWidth)
    // console.log(this.$refs.imageWrapper.clientHeight, this.$refs.imageWrapper.clientWidth)

    this.resizeImageWrapper()
    window.addEventListener('resize', this.resizeImageWrapper);
  },

  destroyed() {
    window.removeEventListener('resize', this.resizeImageWrapper);
  },
  computed: {},
}
</script>

<style lang="less">
.card-display-container {
  display: flex;
  align-items: stretch;
  margin: 0rem;

  &.card-reverse {
    flex-direction: row-reverse;
  }

  .card-image-wrapper, .card-content-wrapper {
    position: relative;
    width: 50%;
  }

  &.content-static-info {

    .card-content-wrapper {
      padding: 6rem 4rem;
      max-width: 750px;
    }
  }

  .card-image-wrapper {
    // height: 60vh;
    display: flex;
    position: relative;
    overflow: hidden;

    .card-image {
      position: absolute;
      top: 0;

      height: 100%;
      width: 100%;
      background-size: cover;
      background-repeat: no-repeat;
      background-position: center center;
      z-index: 1;

      &.blur-background {
        // background-size: cover;
        // z-index: 0;
        // filter: blur(10px) opacity(0.9);

        background-size: cover;
        z-index: 0;
        /* -webkit-filter: blur(10px) opacity(0.2); */
        /* filter: blur(20px) opacity(0.7) brightness(1.4); */
        filter: blur(20px) hue-rotate(-10deg) opacity(0.3);
        // transform: scale(1.6);
      }
    }

    .card-image-blur-wrapper {
      opacity: 0.3;
      /*transform: scale(1.3);*/
      position: absolute;
      /*top: 0;*/
      /*height: 100%;*/
      /*width: 100%;*/
    }

    .card-play-button {
      position: absolute;
      top: 50%;
      left: 50%;
      z-index: 1;
      transform: translate(-50%, -50%);
      color: white;
      opacity: 0.90;
    }
  }

  .card-content-wrapper {
    flex: 1 1 auto;
    padding: 3rem 2rem;
    display: flex;
    flex-direction: column;
    justify-content: center;

    text-align: left;


    .card-sub-title {
      font-size: 0.9rem;
      color: rgba(105, 103, 103, 0.8);
      line-height: 2em;
      margin-bottom: 0.5rem;
    }

    .card-title {
      font-size: 2.2rem;
      line-height: 1.2em;
      margin: 0;
    }

    .card-gym-availability {

    }

    .card-divider {
      padding: 12px 0;
    }

    .card-content {
      font-size: 1.0rem;
      color: rgba(105, 103, 103, 0.8);
      line-height: 1.9em;
      flex: 1 1 0;
    }

  }
}

// @media only screen and (min-width: 1200px) {
//     .card-display-container {
//         .card-content-wrapper {
//             padding: 6rem 4rem !important;
//             width: 750px;
//         }
//     }
// }


@media only screen and (max-width: 1200px) {
  .carosuel {
    position: absolute;
    top: 0;
    left: 0;
  }

  .card-display-container {
    flex-direction: column;

    &.card-reverse {
      flex-direction: column-reverse;
    }

    &.card-default-sm {
      flex-direction: column !important;
    }

    &.content-static-info {
      margin: 1rem;

      .card-content-wrapper {
        padding: 1.5rem;
        max-width: unset;
      }
    }

    .card-image-wrapper {
      padding-top: 50%;
    }

    .card-image-wrapper, .card-content-wrapper {
      width: 100%;

      .card-image {
        padding-top: 50%;
      }

      .card-image-blur-wrapper {
        top: 100%;
        margin-top: -50%;
      }

      .card-sub-title {
        font-size: 1rem;
        // font-size: 0.7rem;
        // line-height: 2em;
      }

      .card-title {
        font-size: 2.2rem;
        line-height: 1.4em;

        // font-size: 1.1rem;
        // line-height: 1.2em;
      }

      .card-content {
        font-size: 1.1rem;
        line-height: 1.4em;
      }
    }
  }
}

@media only screen and (max-width: 500px) {
  .card-display-container {
    .card-image-wrapper, .card-content-wrapper {

      .card-sub-title {
        font-size: 3vw;
      }

      .card-title {
        font-size: 5vw;
        line-height: 1.4em;
      }

      .card-content {
        font-size: 3.6vw;
        line-height: 1.4em;
      }
    }
  }
}
</style>
